
export interface IReport {
    start_time: string,
    end_time: string,
    pjp_id?: string,
    pjp_name?: string,
    pjp_type?: string,
    pjp_status?: string,
    pjp_feature?: string,
    stream_id?: string,
}
export interface IBingoRooms {
    page?: number,
    rows_per_page?: number
}
export interface IChatRooms {
    page?: number,
    rows_per_page?: number,
}
export interface ICreateChatRoom {
    room_name?: string,
    room_description?: string,
    room_id?: number,
}
export interface IChatRoomStatus {
    status: string;
    room_name: string;
    error: string;
}
export interface IChatRoomsInfo {
    created: string,
    description: string,
    id: number,
    name: string,
}
export interface IChatRoomApiInfo {
    bingo_rooms: Array<IChatRoomsInfo>,
    pagination: IPagination,
}
export interface IBingoRoomsInfo {
    game_type: number,
    status: number,
    id: number,
    stream_name: string,
}

export interface IPagination {
    current_page: number,
    rows_per_page: number,
    total_pages: number,
    total_rows: number,
}
export interface IBingoRoomApiInfo {
    bingo_rooms: Array<IBingoRoomsInfo>,
    pagination: IPagination,
}
export interface IStatus {
    status: number,
    stream_id: number,
}
export interface IPostStatus {
    stream_id?: number,
    stream_status?: boolean,
}

export interface roomGametype {
    id: number,
    name: string,
}
export interface IeditRoom {
    id: number,
    name: string,
    variant: string,
    time_zone: string,
    prebuy_enabled: number,
    sit_n_go: number,
    socket_version: number,
    bingo_manager: boolean,
    tournament_enabled: number
}

export interface roomVariant {
    key: string,
    value: string,
}

export interface ICStream {
    name: string,
    game_type: number,
    chat_room_id: number,
    amount_type: number,
    server: string,
    variant: string,
    socket_version: number,
    prebuy_enabled: number,
    bingo_manager: boolean,
    tournament_enabled: number,
    sit_n_go: number
}
export interface amountType {
    id: number,
    name: string,
}
export interface socketversions {
    id: number,
    value: string,
}

export interface IAuditReport {
    chat_type?: string,
    chat_room?: string,
    channel_name?: string,
    search?: string,
    start_time?: string,
    end_time?: string,
}

export interface IHostReport {
    alias?: string,
    frm_date?: string,
    to_date?: string,
}
export interface IStreamStatus {
    stream_id?: number,
    stream_status?: number,
}
export interface IChangeWordp {
    oldPassword: string,
    newPassword: string,
    verifyPassword: string
}
export interface IChangeWordpData {
    new_password?: string,
    old_password?: string,
    username?: string,
    api_key?: string,
}
export interface IScheduleObj {
    session_id?: number,
    stream_id?: number,
    start_day: number,
    end_day: number,
    start_time: string,
    end_time: string,
    session_type?: string,
    title?: string,
    session_name?: string,
    schedule_id?: number,
    type?: string,
    destination_room_id?: number,
    linked_to?: number
    origin_room_id?: Array<number>,// if “config child room” is ticked
}
export interface ICreateSchedule {
    session_id: number,
    stream_id: number,
    start_day: number,
    end_day: number,
    start_time: string,
    end_time: string,
    session_type: string,
    destination_room_id?: number,
    origin_room_id?: Array<number>,// if “config child room” is ticked
}

export interface IManageSchedule {
    start_day: number;
    end_day: number;
    start_time: string;
    end_time: string;
    title: string;
}
export interface IUpdateSchedule {
    schedule_id: number,
    session_id: number,
    start_day: number,
    end_day: number,
    start_time: string,
    end_time: string,
    session_type: string,
    stream_id: number,
    destination_room_id: number,
    origin_room_id: Array<number>
}
export interface ICreateSession {
    name: string,
    bingo_type: number,
}
export interface IDeleteSession {
    session_id: number,
    game_orders: Array<number>
}

export interface IUpdateStream {
    id: number,
    name: string,
}
export interface IUpdateSession {
    session_id?: number,
    session_name: string,
    bingo_type: number,
    isNew?: boolean,
    type?: string
}
export interface ICreateChatroom {
    id?: number,
    name: string,
    description: string,
}
export interface IReqFrontend {
    network_code: string,
    platform: string
}
export interface IAssignedRoomApiData {
    frontend_id: number,
    stream_id: number,
    status: number,
    theme_name: string,
    chatroom_id: number,
    category: string,
    isLsUrl: any,
    lsUrl: string,
    enable: number,
    file_details?: any,
}
export interface IPreBuyReportForm {
    start_date?: string,
    start_time?: string,
    end_date?: string,
    end_time?: string,
    active?: string,
    completed?: string,
    cancelled?: string,
    failed?: string,
    rowsPerPage?: string,
    full_site_code?: string,
    game_id?: string,
    stream_id?: string,
    alias?: string,
    account_id?: string,
    report_by?: string,
}
export interface IPreBuyReport {
    start_date?: string,
    end_date?: string,
    status?: any,
    page?: number,
    rows_per_page?: number,
}
export interface IVoidGamesReportForm {
    start_date?: string,
    start_time?: string,
    end_date?: string,
    end_time?: string,
    rowsPerPage?: string
}
export interface IVoidGamesReport {
    start_date?: string,
    end_date?: string,
    page?: number,
    rows_per_page?: number,
}
export interface IDataReportForm {
    start_date?: string,
    start_time?: string,
    end_date?: string,
    end_time?: string,
    rowsPerPage?: string
}
export interface IGameLogsData {
    from_date: string,
    to_date: string,
    search_by: object,
    export_format: string,
    export: boolean,
    display: boolean,
    page?: number,
    rows_per_page: number
}

export class SearchBy {
    search: string = '';
    search_item: string = 'stream_name'
}
export class GameLogsData {
    from_date: string;
    to_date: string;
    search_by: SearchBy = new SearchBy();
    export_format: string = 'excel';
    export: boolean = false;
    display: boolean;
    page?: number = 1;
    rows_per_page: number = 20;
}
export class IPlayerEligibilityReportForm {
    start_date?: string;
    start_time?: string;
    end_date?: string;
    end_time?: string;
    clubName: string;
    enable: string;
    disable: string;
    exportFormat: string;
}
export class IPlEligibleReport {
    frm_date?: string;
    to_date?: string;
    club_id?: string;
    category?: any;
    page?: number;
    rows_per_page?: number;
}
export interface IGameHistory {
    account_id?: number,
    account_id_type?: string,
    outcome?: string,
    stream?: number,
    all_streams?: boolean,
    from_date?: string,
    to_date?: string,
    page?: number,
    rows_per_page?: number,
}

export interface IMenusList {
    page?: number,
    rows_per_page?: number,
    conditions?: any,
}

export interface ICreateMenu {
    id?: number,
    name?: string,
    description?: string,
    address?: string,
    visible?: number,
    level?: number,
    parent?: number,
    priority?: number
}
export interface IUsersList {
    page?: number,
    rows_per_page?: number,
    user_info?: Object,
    user_type?: String
}
export interface ICreateUser {
    name?: string,
    alias?: string,
    password?: string,
    category_id?: number,
    system_id?: string;
    status?: number,
    network?: string,
    affiliate_code?: string,
    account_id?: number,

}
export interface IPrebuyRefresh {
    room_id?: Array<number>,
    no_of_weeks?: number,
    no_of_games?: number,
}
export interface Ino_weeks {
    id: number,
    value: string,
}
export interface Irooms {
    stream_id: number,
    stream_name: string,
}
export interface IgmsChangeLogsForm {
    start_date?: string,
    start_time?: string,
    end_date?: string,
    end_time?: string,
    rowsPerPage?: string
}
export interface IchangeLogsReport {
    start_date?: string,
    end_date?: string,
    page?: number,
    rows_per_page?: number,
}
export interface IgmsUsersActivityForm {
    start_date?: string,
    start_time?: string,
    end_date?: string,
    end_time?: string,
    rowsPerPage?: string
}
export interface IuserActivitysReport {
    start_date?: string,
    end_date?: string,
    page?: number,
    rows_per_page?: number,
    user_id?: number,
}
export interface ISessionBingoList {
    page?: number,
    rows_per_page?: number,
    start_time?: string,
    end_time?: string,
    flag?: string;
}

export interface ImultiMediaData {
    fileType: string,
    fileData: File,
    acceptedTypes: Array<string>,
    maxSize: number,
    maxWidth?: number,
    maxHeight?: number,
    isFixed?: string
}

// Enums

export enum GameType {
    POINTS = 'points',
    TICKETS = 'tickets',
    LEADER_BOARD = 'leader_board',
}
